import { render, staticRenderFns } from "./AddMeta.vue?vue&type=template&id=2f0184c1&"
import script from "./AddMeta.vue?vue&type=script&lang=js&"
export * from "./AddMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports